module.exports = __webpack_public_path__ + "img/mountain_break.5b59736c.jpg";